import React, { createRef } from "react";
import { DKIcons, DKIcon, DKSearchBar } from "deskera-ui-library";
import utility, { isMacintosh } from "../../utility/Utility";
import { TableManger, TABLES } from "../../managers/TableManger";
import SideBarService from "../../services/sidebar";
import { connect } from "react-redux";
import Utility from "../../utility/Utility";

import { isEqual } from "lodash";
import debounce from "../../utility/Debounce";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
/*
columns
className
customCardRender(card, colIndex, rowIndex)
customHeaderRender(column, colIndex)
onCardDrop(card, fromColumnIndex, toColumnIndex)
onCardDragStart(card, columnIndex)
allowAddingCard,
addCardRenderer
onCardAdd(columnIndex)
allowColumnShifting
onColumnShift(columnIndex,toColumnIndex)
*/
class DKKanban extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: this.props.columns,
      width: SideBarService.getContainerWidth(),
      showLoadMoreOption: true
    };
    this.tableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    this.stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    this.dealTableId = TableManger.getTableId(TABLES.CANDIDATE);
    this.draggedCard = null;
    this.fromColumnIndex = null;
    this.cardOverIndex = null;
    this.toColumnIndex = null;
    this.cardBeingDraggedIndex = null;
    this.columnBeingDraggedIndex = null;
    this.bottomScrollIntersection = createRef();
    this.setUpIntersectionObserver();
  }
  setUpIntersectionObserver() {
    const config = { rootMargin: '0px', threshold: 0.1 };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0 && entry.isIntersecting) {
          const hasMoreDeals = this.props?.deals?.totalCount > this.props.deals?.data?.length;
          this.setState({
            ...this.state,
            // showLoadMoreOption: hasMoreDeals && !this.state.showLoadMoreOption // use in future
          });
        }
      });
    }, config);
    console.log('this.observer', this.observer);
  }

  onDragStart = (e, card, columnIndex, cardIndex) => {
    e.dataTransfer.dropEffect = "move";
    this.draggedCard = card;
    this.cardBeingDraggedIndex = cardIndex;
    this.fromColumnIndex = columnIndex;
    if (this.props.onDragStart) this.props.onCardDragStart(card, columnIndex);
  };
  onDrop = (e, index) => {
    let { columns } = this.state;
    if (this.columnBeingDraggedIndex != null) {
      this.props.onColumnShift(
        this.columnBeingDraggedIndex,
        this.toColumnIndex
      );
      this.columnBeingDraggedIndex = null;
    } else {
      if (!this.draggedCard) return;
      columns[this.fromColumnIndex].candidate.splice(this.cardBeingDraggedIndex, 1);
      if (this.cardOverIndex !== null || this.cardOverIndex !== undefined) {
        columns[this.toColumnIndex].candidate.splice(
          this.cardOverIndex,
          0,
          this.draggedCard
        );
      } else {
        columns[this.toColumnIndex].candidate.push(this.draggedCard);
      }
      // this.draggedCard = null;
      this.cardOverIndex = null;
      this.setState(
        {
          columns,
        },
        () => this.removeCardTransition(this.toColumnIndex)
      );
      if (this.props.onCardDrop)
        this.props.onCardDrop(
          this.draggedCard,
          this.fromColumnIndex,
          this.toColumnIndex
        );
    }
  };
  onDragOver = (e, index) => {
    let oldToColumnIndex = this.toColumnIndex;
    this.toColumnIndex = index;
    if (oldToColumnIndex !== this.toColumnIndex)
      {
        this.removeCardTransition(oldToColumnIndex);
      }
    e.preventDefault();
  };
  onCardDragOver = (e, colIndex, rowIndex) => {
    if (this.toColumnIndex !== colIndex || rowIndex !== this.cardOverIndex)
      {
        this.removeCardTransition(colIndex);
      }
    this.cardOverIndex = rowIndex;
    this.addCardAnimation();
    e.preventDefault();
  };
  onCardDrop = (e) => {
    e.preventDefault();
  };
  addCardAnimation = () => {
    if (!this.draggedCard) return;
    if (this.cardOverIndex !== null || this.toColumnIndex !== undefined) {
      let columnEle = document.getElementById(`column-${this.toColumnIndex}`);
      if (columnEle && columnEle.children) {
        Array.from(columnEle.children).forEach((element, index) => {
          if (index >= this.cardOverIndex) {
            if (
              this.toColumnIndex === this.fromColumnIndex &&
              this.cardBeingDraggedIndex === this.cardOverIndex
            )
              return;
            element.style.transform = `translate(0,${element.clientHeight}px)`;
          }
        });
      }
    }
  };
  removeCardTransition = (toColumnIndex) => {
    if (!Utility.isEmpty(toColumnIndex) || toColumnIndex === 0) {
      let columnEle = document.getElementById(`column-${toColumnIndex}`);
      if (!Utility.isEmpty(columnEle) && !Utility.isEmpty(columnEle.children)) {
        Array.from(columnEle.children).forEach((element, index) => {
          element.style.transform = null;
        });
      }
    }
  };
  onMouseOver = (e, colIndex) => {
    if (this.props.allowColumnShifting)
      document
        .getElementById(`column-header-${colIndex}`)
        .parentNode.setAttribute("draggable", "true");
  };
  onMouseLeave = (e, colIndex) => {
    if (this.props.allowColumnShifting)
      document
        .getElementById(`column-header-${colIndex}`)
        .parentNode.setAttribute("draggable", "false");
  };
  onColumnDragStart = (e, colIndex) => {
    if (
      this.props.allowColumnShifting &&
      e.target.classList.contains("dk-kanban-stage-wrapper")
    ) {
      e.dataTransfer.dropEffect = "move";
      this.columnBeingDraggedIndex = colIndex;
    }
  };
  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.columns, nextProps.columns)) {
      this.setState({
        columns: nextProps.columns,
      }, () => {
        if ( !Utility.isEmptyObject(this.bottomScrollIntersection?.current)) {
          this.observer.unobserve(this.bottomScrollIntersection.current);
          this.observer.observe(this.bottomScrollIntersection.current);
        }
      });
    }
  }
  componentDidMount() {
    this.windowSizeUpdated();
    window.addEventListener("resize", this.windowSizeUpdated);
    window.addEventListener('onSideBarChange', this.windowSizeUpdated);
    if (!Utility.isEmptyObject(this.bottomScrollIntersection?.current)) {
      this.observer.observe(this.bottomScrollIntersection.current);
    }

  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.windowSizeUpdated);
    window.removeEventListener('onSideBarChange', this.windowSizeUpdated);
    if(this.observer.unobserve && this.bottomScrollIntersection?.current) {
      this.observer.unobserve(this.bottomScrollIntersection.current);
    }
  }

  windowSizeUpdated = () => {
    this.setState({ width: SideBarService.getContainerWidth() });
  };
  onSearch=(value)=>{
    if(this.props.onSearch) {
      this.props.onSearch(value);
    }
  }
  render() {
    return (
      <>
      <div className="row">
      <DKSearchBar
          className=" ml-auto mt-r"
                searchText={''}
                onSearch={debounce(this.onSearch,500)}
              />
      </div>
        <div
          id={`dk-kanban-board`}
          className={`dk-kanban column parent-width align-items-stretch mt-xl ${this.props?.className
            } ${isMacintosh() ? " hide-scroll-bar" : " show-scroll-bar"}`}
          style={{ ...styles.board, width: this.state.width, height: "96%" }}
          onColumnDrop={this.onColumnDrop}
        >
          <div className="row align-items-stretch">
            {this.state.columns.map((column, colIndex) => {
              return (
                <div
                  className={`dk-kanban-stage-wrapper column `}
                  style={styles.stageWrapper}
                  
                  onDrop={(e) => this.onDrop(e, colIndex)}
                  onDragOver={(e) => this.onDragOver(e, colIndex)}
                  onDragStart={(e) => this.onColumnDragStart(e, colIndex)}
                >
                  <div
                    id={`column-header-${colIndex}`}
                    className={`parent-width dk-kanban-stage-header-wrapper ${this.props.allowColumnShifting ? "cursor-move" : ""
                      }`}
                    onMouseOver={(e) => this.onMouseOver(e, colIndex)}
                    onMouseLeave={(e) => this.onMouseLeave(e, colIndex)}
                  >
                    {this.props.customHeaderRender
                      ? this.props.customHeaderRender(column, colIndex)
                      : this.defaultColumnHeader(column, colIndex)}
                  </div>
                  <div
                    id={`column-${colIndex}`}
                    className="dk-kanban-card-wrapper parent-height p-s"
                    style={styles.cardWrapper}
                  >
                    {column.candidate &&
                      column.candidate.map((card, rowIndex) =>
                        this.getCard(card, colIndex, rowIndex)
                      )}
                    {this.props.allowAddingCard && this.getAddCardView(colIndex)}
                  </div>
                </div>
              );
            })}
          </div>
          
          {(!this.props.loading && this.props.hasMoreLoad) && 
          <div className="row parent-width justify-content-center">
          <div
            className="text-underline border width-auto p-l border-radius-m cursor-hand"
            onClick={() => {
              this.props?.onLoadMore?.()
            }}
          >
            Load More
          </div>
        </div>}
        </div>
      </>
    );
  }

  getCard = (card, colIndex, rowIndex) => {
    return (
      <div
        id={`column-${colIndex}-card-${rowIndex}`}
        draggable={PermissionUtils.hasAccess(MODULE.JOB_PIPELINE,[ACTION.EDIT])}
        className="dk-kanban-card parent-width row mt-r dk-kanban-card-transistion"
        onDragStart={(e) => this.onDragStart(e, card, colIndex, rowIndex)}
        onDragOver={(e) => this.onCardDragOver(e, colIndex, rowIndex)}
        onDrop={(e) => this.onCardDrop(e)}
      >
        {this.props.customCardRender
          ? this.props.customCardRender(card, colIndex, rowIndex)
          : this.defaultCardRenderer(card, colIndex, rowIndex)}
      </div>
    );
  };
  defaultColumnHeader = (column, colIndex) => {
    return <div className="fs-xl fw-h mb-l">{`column ${colIndex + 1}`}</div>;
  };
  defaultCardRenderer = (card, colIndex, rowIndex) => {
    return (
      <div className="dk-kanban-default-card parent-width fw-b p-xl cursor-move">
        {card.toString()}
      </div>
    );
  };
  getAddCardView = (colIndex) => {
    return this.props.addCardRenderer ? (
      this.props.addCardRenderer(colIndex)
    ) : (
      <div
        className={`dk-kanban-add-card d-flex justify-content-center parent-width border-mc cursor-hand mt-r`}
        style={styles.addCard}
        onClick={() => this.props.onCardAdd(colIndex)}
      >
        <DKIcon
          src={DKIcons.ic_add}
          className="pt-s pb-s"
          style={styles.addCardButton}
        />
      </div>
    );
  };
}
const styles = {
  board: {
    overflowX: "scroll",
    overflowY: "visible",
    gap: "0px",
    borderRadius: "4px",
  },
  stageWrapper: {
    minWidth: 263,
    borderRight: "1px solid rgb(230, 230, 230)",
    minHeight:'100%'
  },
  cardWrapper: {
    width: "92%",
    paddingLeft: "4%",
    paddingRight: "4%",
  },
  addCard: {
    backgroundColor: "#fff",
    width: "94%",
    marginLeft: "3%",
    marginRight: "3%",
  },
  addCardButton: {
    width: "25px",
    height: "25px",
  },
};
const mapStateToProps = (state) => ({
  deals: state?.records?.data[TABLES.CANDIDATE],
  candidate: state?.records?.data[TABLES.CANDIDATE]
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DKKanban);
